import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = anon, object = authed
  const token = typeof window !== "undefined" ? localStorage.getItem("weave_admin_token") : null;

  useEffect(() => {
    if (!token) {
      setAdmin(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem("weave_admin_token");
        setAdmin(false);
      });
  }, [token]);

  const login = (data) => {
    localStorage.setItem("weave_admin_token", data.access_token);
    setAdmin({ email: data.email, name: data.name });
  };

  const logout = () => {
    localStorage.removeItem("weave_admin_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
